import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Est-ce que tous les élèves-athlètes bénéficient du service de tutorat ? ",
        answers: ["Oui, tous les élèves-athlètes DAM ont des séances de tutorat avec les tuteurs bénévoles. ", 
            "Non, seulement ceux et celles ont des échecs scolaires. ", 
            "Non, seulement ceux et celles qui en font la demande. "],
        correctAnswer: 2,
        explanation: "Aucun élève-athlète n'est obligé d'être accompagné par un tuteur bénévole. Ils s'inscrivent sur une base volontaire. "
    },
];

export function Step1Page() {
    return (
        <Step
            stepNumber="1"
            title="Première capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video1.mp4`}
            redirectURL="/formation/2"
            questions={questions}
        />
    );
} 